/* Interfaces */
export type HeaderResizeDetail = {
  height: number;
};

export type HeaderResizedEvent = Event & {
  detail: HeaderResizeDetail;
};

export type HeaderResizedEventName = {
  [key in typeof headerResizedEventKey]: () => void;
};

export const headerResizedEventKey = "header-resized";

/* Observer Maps */
export const resizeObserverSet = new WeakSet<HTMLElement>();

/* Functions Handler */
export function setupHeaderResizeObserver() {
  window.addEventListener("DOMContentLoaded", () => {
    const header = document.querySelector("header");
    if (!header) return console.warn("No header found.");

    if (resizeObserverSet.has(header)) {
      console.warn("A ResizeObserver is already attached to the header.");
      return;
    }

    let lastHeight = header.offsetHeight;
    const observer = new ResizeObserver((entries) => {
      for (const entry of entries) {
        const newHeight = entry.contentRect.height;
        if (newHeight !== lastHeight) {
          lastHeight = newHeight;
          const event = new CustomEvent<HeaderResizeDetail>(
            headerResizedEventKey,
            {
              detail: { height: newHeight },
              bubbles: true,
            },
          );
          header.dispatchEvent(event);
        }
      }
    });

    observer.observe(header);
    resizeObserverSet.add(header);
  });
}
